module.exports = __webpack_public_path__ + "img/bpbd.4f292139.png";